import { Component, OnInit, HostListener, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { UserService } from "src/app/services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-addresslog",
  templateUrl: "./kyc.component.html",
  styleUrls: ["./kyc.component.scss"],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class KycComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  public userlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  username;
  userId;
  noData: boolean;
  public profileDetails;
  presentKyaData: boolean;
  item: any;
  displayBasic: boolean | undefined;
  public showHighlightImg = "";
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  rejectKyc: boolean;
  rejectUpdateForm: FormGroup;
  submitted: boolean;
  UserKycData: any;
  viewReason: any;
  rejectKycReasonView: boolean = false;
  mobileNumber:Number;
  constructor(
    private userService: UserService,
    private activeroute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private titlecasePipe: TitleCasePipe,
    private messageService: MessageService,
    private router: Router,
    private formBuilder: FormBuilder,

  ) { }

  ngOnInit() {
    this.userId = this.activeroute.snapshot.params.id;
    this.rejectUpdateForm = this.formBuilder.group(
      {
        comment: ["", { validators: [Validators.required], updateOn: "blur", },]
      });
  }
  changeStatus(user) {
    this.confirmationService.confirm({
      message: 'Do you confirm your decision to approve and activate the KYC for ' + (this.titlecasePipe.transform(user.userdetail[0].fullName)) + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var userData = {
          status: true
        }


        this.userService.updateUserKyc(user.Id, userData).pipe(takeUntil(this.destroy$)).subscribe(
          (data) => {

            this.messageService.add({
              key: "toastmsg",
              severity: "success",
              summary: "Successful",
              detail: "User Status Updated",
              life: 3000,
            });
            setTimeout(() => {
              this.router.routeReuseStrategy.shouldReuseRoute = () => false;
              this.router.onSameUrlNavigation = 'reload';
              this.router.navigate([this.router.url]);
            }, 2000);
          },
          (err) => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => { }
    });
  }
  loadUserKyc(event: LazyLoadEvent) {

    var query = "?filterDisable=false$filterByPrimary=true&filterByuserId=" + this.userId;
    this.userService.getUserKycDetailsList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        this.userService.getUser(this.userId).pipe(takeUntil(this.destroy$)).subscribe((detail) => {
          this.username = detail["fullName"];
          this.mobileNumber = detail['mobileNumber']
        });
        this.totalRecords = data.totalCount;

        this.userlist = data.items;
        // this.userlist.forEach(ele => {
        //   if(ele.panCardNumber!=null){
        //   ele.panCardNumber=CryptoJS.AES.decrypt(ele.panCardNumber, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)}
        //   if(ele.gstNumber!=null){
        //   ele.gstNumber=CryptoJS.AES.decrypt(ele.gstNumber, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)}
        //   if(ele.adharCardNumber!=null){
        //   ele.adharCardNumber=CryptoJS.AES.decrypt(ele.adharCardNumber, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)}
        //   ele.bankName=CryptoJS.AES.decrypt(ele.bankName, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        //   ele.accountNumber=CryptoJS.AES.decrypt(ele.accountNumber, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        //   ele.ifsc=CryptoJS.AES.decrypt(ele.ifsc, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        // })
        if (JSON.stringify(data) === '{}') {

          this.noData = false;
        } else {

          this.noData = true;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  addKyc(id) {
    this.router.navigate(['/manage/user/kyc/add-kyc/' + id]);
  }

  public openHightlightImage(userlist) {
    this.displayBasic = true
    this.showHighlightImg = userlist.pancardPic;
  }

  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }
  get f() {
    return this.rejectUpdateForm.controls;
  }
  showrejectmodal(data) {
    this.rejectKyc = true;
    this.UserKycData = data
  }
  changeStatusToReject() {
    this.submitted = true;
    if (this.rejectUpdateForm.invalid) {
      return;
    }

    var userData = {
      isRejected: true,
      status: false,
      rejectedReason: this.rejectUpdateForm.value.comment
    }
    // return;

    this.userService.updateUserKyc(this.UserKycData.Id, userData).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {

        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: "User Status Updated",
          life: 3000,
        });
        setTimeout(() => {

          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([this.router.url]);
        }, 2000);
      },
    )

  }
  viewRejectReasonModal(data) {
    this.rejectKycReasonView = true
    this.viewReason = data.rejectedReason
  }

    addColumns() {
    this.hide = false;

  }

  //use to remove columns
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
